module.exports = __webpack_public_path__ + "static/img/img30.0523705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img30.png
// module id = NFfc
// module chunks = 1